import React from 'react';
import { Link } from 'react-router-dom';
import HtmlRenderer from 'v2/common/HtmlRenderer/HtmlRenderer';
import styles from './associationItem.module.scss';
import { Contact, DataProduct, DataVendor } from 'v2/models';
import { getContactNameToLink } from 'v2/utils/ContactUtils';

interface GenericAssociationTabContentProps {
  associationParentName?: string;
  associationItem: DataProduct | DataVendor | Contact;
}

const GenericAssociationTabContent = ({
  associationParentName,
  associationItem,
}: GenericAssociationTabContentProps) => {
  if ((associationItem as DataVendor).domain !== undefined) {
    const dataVendor = associationItem as DataVendor;
    return (
      <div>
        <div>{dataVendor.name}</div>
        <div>
          {dataVendor.domain && <HtmlRenderer source={dataVendor.domain} />}
        </div>
      </div>
    );
  }

  const entityType =
    (associationItem as Contact).contact_owner !== undefined
      ? 'contact'
      : 'data-set';

  const contactEmail =
    entityType === 'contact'
      ? (associationItem as Contact).primary_associations?.email?.email
      : null;

  return (
    <div>
      <Link
        data-testid={`primary_dataset`}
        key={associationItem?.id}
        to={{
          pathname: `/${entityType}-details/${associationItem?.id}/detail`,
          state: {
            counterToGoBack: -1,
            backLinkTitle: associationParentName,
          },
        }}
      >
        {entityType === 'data-set'
          ? associationItem?.name
          : getContactNameToLink(associationItem as Contact)}
      </Link>
      {contactEmail && (
        <p>
          <a href={`mailto:${contactEmail}`}>{contactEmail}</a>
        </p>
      )}
      {entityType === 'data-set' &&
        (associationItem as DataProduct)?.data_vendor && (
          <div className={styles.subtitle}>
            {(associationItem as DataProduct)?.data_vendor?.name}
          </div>
        )}
    </div>
  );
};

export default GenericAssociationTabContent;
